import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ICondicionalRelease } from 'src/app/shared/interfaces/condicional/icondicional.release';
import { ICondicionalTrigger } from 'src/app/shared/interfaces/condicional/icondicional.trigger';
import { ConditionalActions } from 'src/app/store/condicional/condicional.actions';
import { selectRelease, selectTrigger } from 'src/app/store/condicional/condicional.selectors';
import { loadUnidade } from 'src/app/store/unidade/unidade.actions';
import { selectUnidadeLista } from 'src/app/store/unidade/unidade.selectors';

@Component({
  selector: 'app-condicional-lista',
  templateUrl: './condicional-lista.component.html',
  styleUrls: ['./condicional-lista.component.scss']
})
export class CondicionalListaComponent implements OnInit {
  mostrarConfirmarTelemedicina: boolean = false;
  mostrarConfirmarReceituarioEvolucao: boolean = false;
  mostrarConfirmarAgendaDisparos: boolean = false;
  mostrarConfirmarTelefonia: boolean = false

  itemMenuIndex: number = 0

  ref: DynamicDialogRef | undefined;

  release$ = this.store.select(selectRelease);
  trigger$ = this.store.select(selectTrigger);
  listaUnidades$ = this.store.select(selectUnidadeLista);

  /* forms */

  releaseForm = this.fb.group({
    telemedicina: [false],
    receituarioEvolucao: [false],
    telefoniaNuvem: [false]
  })

  triggerForm = this.fb.group({
    enableReviews: this.fb.group({
      trigger: { label: "Automático" },
      channel: { label: "Whatsapp" },
      units: []
    }),
    enable24hConfirmation: this.fb.group({
      channel: { label: "Whatsapp" },
      units: []
    }),
    enable48hConfirmation: this.fb.group({
      channel: { label: "Whatsapp" },
      units: []
    }),
    enable72hConfirmation: this.fb.group({
      channel: { label: "Whatsapp" },
      units: []
    }),
    enableManualConfirmation: this.fb.group({
      channel: { label: "Whatsapp" },
      units: []
    }),
    sendDataAfterBooking: this.fb.group({
      channel: { label: "Whatsapp" },
      units: []
    }),
    sendScheduleReminders: this.fb.group({
      channel: { label: "Whatsapp" },
      units: []
    }),
    sendDayBeforeReminder: this.fb.group({
      channel: { label: "Whatsapp" },
      units: []
    }),
    nextAppointmentReminder: this.fb.group({
      channel: { label: "Whatsapp" },
      units: []
    }),
    waitingListNotification: this.fb.group({
      channel: { label: "Whatsapp" },
      units: []
    }),
    appointmentCancellationNotification: this.fb.group({
      channel: { label: "Whatsapp" },
      units: []
    }),
    appointmentPreconfirmation: this.fb.group({
      channel: { label: "Whatsapp" },
      units: []
    })
  })

  constructor(
    private store: Store,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    /* this.store.subscribe(state => console.log(state)) */

    const clientId = 1


    this.store.dispatch(ConditionalActions.loadRelease({ id: clientId }))
    this.store.dispatch(ConditionalActions.loadTrigger({ id: clientId }))
    this.store.dispatch(loadUnidade());

    this.release$.subscribe({

      next: (res: ICondicionalRelease) => {
        const response: Array<String> = res.serviceReleaseSettingCollection

        /* console.log('resposta do servidor', response) */
        /* console.log('Release', this.releaseForm.value.receituarioEvolucao) */

        if (response.includes('Telemedicina')) {
          this.setTelemedicina()
        }

        if (res.serviceReleaseSettingCollection.includes('Receituário e Evolução')) {
          this.setReceituarioEvolucao()
        }

        if (res.serviceReleaseSettingCollection.includes('Telefonia em Nuvem')) {
          this.setTelefoniaNuvem()
        }

      },
      error: (error) => console.log('Erro ao carregar Release: ', error)
    })

    this.trigger$.subscribe({
      next: (res: any) => {
        /* console.log(' Trigger: ', res) */

        this.triggerForm.patchValue({

          enableReviews: ({
            trigger: { label: res.enableReviews.trigger },
            channel: { label: res.enableReviews.channel },
            units: res.enableReviews.units
          }),
          enable24hConfirmation: ({
            channel: { label: res.enable24hConfirmation.channel },
            units: res.enable24hConfirmation.units
          }),
          enable48hConfirmation: ({
            channel: { label: res.enable48hConfirmation.channel },
            units: res.enable48hConfirmation.units
          }),
          enable72hConfirmation: ({
            channel: { label: res.enable72hConfirmation.channel },
            units: res.enable72hConfirmation.units
          }),
          enableManualConfirmation: ({
            channel: { label: res.enableManualConfirmation.channel },
            units: res.enableManualConfirmation.units
          }),
          sendDataAfterBooking: ({
            channel: { label: res.sendDataAfterBooking.channel },
            units: res.sendDataAfterBooking.units
          }),
          sendScheduleReminders: ({
            channel: { label: res.sendScheduleReminders.channel },
            units: res.sendScheduleReminders.units
          }),
          sendDayBeforeReminder: ({
            channel: { label: res.sendDayBeforeReminder.channel },
            units: res.sendDayBeforeReminder.units
          }),
          nextAppointmentReminder: ({
            channel: { label: res.nextAppointmentReminder.channel },
            units: res.nextAppointmentReminder.units
          }),
          waitingListNotification: ({
            channel: { label: res.waitingListNotification.channel },
            units: res.waitingListNotification.units
          }),
          appointmentCancellationNotification: ({
            channel: { label: res.appointmentCancellationNotification.channel },
            units: res.appointmentCancellationNotification.units
          }),
          appointmentPreconfirmation: ({
            channel: { label: res.appointmentPreconfirmation.channel },
            units: res.appointmentPreconfirmation.units
          })


        })

        /* console.log('form apos patch value', this.triggerForm) */


      },
      error: (error) => console.log('Erro ao carregar Trigger: ', error)
    })

    // this.listaUnidades$.subscribe({
    //   next: (res: any) => console.log('lista de unidades: ', res)
    // })


  }

  setTelemedicina() {
    this.releaseForm.patchValue({
      telemedicina: true
    })
  }

  setReceituarioEvolucao() {
    this.releaseForm.patchValue({
      receituarioEvolucao: true
    })
  }

  setTelefoniaNuvem() {
    this.releaseForm.patchValue({
      telefoniaNuvem: true
    })
  }

  setItemMenuIndex(event: any) {
    this.itemMenuIndex = event
  }

  openConfirmationDialog(item: string) {

    switch (item) {
      case 'Telemedicina':
        this.releaseForm.value.telemedicina ? this.mostrarConfirmarTelemedicina = true : this.onSubmit()
        break;

      case 'ReceituarioEvolucao':
        this.releaseForm.value.receituarioEvolucao ? this.mostrarConfirmarReceituarioEvolucao = true : this.onSubmit()
        break;

      case 'AgendaDisparos':
        this.mostrarConfirmarAgendaDisparos = true;
        break;

      case 'Telefonia':
        this.releaseForm.value.telefoniaNuvem ? this.mostrarConfirmarTelefonia = true : this.onSubmit()
        break;
    }
  }

  public onCancel(param: string) {

    switch (param) {
      case 'telemedicina':
        this.releaseForm.patchValue({
          telemedicina: false
        })
        break;
      case 'receituario_evolucao':
        this.releaseForm.patchValue({
          receituarioEvolucao: false
        })
        break;
      case 'telefonia_nuvem':
        this.releaseForm.patchValue({
          telefoniaNuvem: false
        })
        break;
    }

    this.closeDialog()

  }

  public closeDialog() {

    this.ref?.destroy()

    this.mostrarConfirmarTelemedicina = false;
    this.mostrarConfirmarReceituarioEvolucao = false;
    this.mostrarConfirmarAgendaDisparos = false;
    this.mostrarConfirmarTelefonia = false;
  }

  public onSubmit(param?: string) {

    if (param === 'disparos') {

      const form = this.triggerForm.value

      let req: ICondicionalTrigger = {
        clientId: 1, /* mock */
        enableReviews: {
          trigger: form.enableReviews?.trigger?.label as string,
          channel: form.enableReviews?.channel?.label as string,
          units: form.enableReviews?.units as any
        },
        enable24hConfirmation: {
          channel: form.enable24hConfirmation?.channel?.label as string,
          units: form.enable24hConfirmation?.units as any
        },
        enable48hConfirmation: {
          channel: form.enable48hConfirmation?.channel?.label as string,
          units: form.enable48hConfirmation?.units as any
        },
        enable72hConfirmation: {
          channel: form.enable72hConfirmation?.channel?.label as string,
          units: form.enable72hConfirmation?.units as any
        },
        enableManualConfirmation: {
          channel: form.enableManualConfirmation?.channel?.label as string,
          units: form.enableManualConfirmation?.units as any
        },
        sendDataAfterBooking: {
          channel: form.sendDataAfterBooking?.channel?.label as string,
          units: form.sendDataAfterBooking?.units as any
        },
        sendScheduleReminders: {
          channel: form.sendScheduleReminders?.channel?.label as string,
          units: form.sendScheduleReminders?.units as any
        },
        sendDayBeforeReminder: {
          channel: form.sendDayBeforeReminder?.channel?.label as string,
          units: form.sendDayBeforeReminder?.units as any
        },
        nextAppointmentReminder: {
          channel: form.nextAppointmentReminder?.channel?.label as string,
          units: form.nextAppointmentReminder?.units as any
        },
        waitingListNotification: {
          channel: form.waitingListNotification?.channel?.label as string,
          units: form.waitingListNotification?.units as any
        },
        appointmentCancellationNotification: {
          channel: form.appointmentCancellationNotification?.channel?.label as string,
          units: form.appointmentCancellationNotification?.units as any
        },
        appointmentPreconfirmation: {
          channel: form.appointmentPreconfirmation?.channel?.label as string,
          units: form.appointmentPreconfirmation?.units as any
        }

      }

      /* console.log('req de trigger: ', req) */

      this.store.dispatch(ConditionalActions.editTrigger({ trigger: req, id: req.clientId }))
      this.closeDialog();
      return
    }

    let req: ICondicionalRelease = {
      clientId: 1 /* mock */,
      serviceReleaseSettingCollection: []
    }

    this.releaseForm.value.telemedicina ? req.serviceReleaseSettingCollection.push('Telemedicina') : null
    this.releaseForm.value.receituarioEvolucao ? req.serviceReleaseSettingCollection.push('Receituário e Evolução') : null
    this.releaseForm.value.telefoniaNuvem ? req.serviceReleaseSettingCollection.push('Telefonia em Nuvem') : null

    this.store.dispatch(ConditionalActions.editRelease({ release: req, id: req.clientId }))

    this.closeDialog()

  }

  /* dados mocados */

  insideMenuData: Array<{ title: string, icon: string }> = [
    {
      title: 'Telemedicina',
      icon: 'browser-plus'
    },
    {
      title: 'Receituário e Evolução',
      icon: 'clipboard-plus'
    },
    {
      title: 'Agendamento Online',
      icon: 'calendar-time'
    },
    {
      title: 'Agenda de Disparos',
      icon: 'calendar-share'
    },
    {
      title: 'Telefonia',
      icon: 'phone'
    }
  ]

}